
import { mapGetters, mapState } from 'vuex'
import InfoLeft from './InfoLeft'
import InfoRight from './InfoRight'
import Review from '~/components/reviews/Review'
import ChevronIcon from '~/assets/icons/chevron.svg'

export default {
  name: 'ReviewsContainer',
  components: {
    Review,
    ChevronIcon,
    InfoLeft,
    InfoRight,
  },
  data () {
    return {
      isOnStart: true,
      isOnEnd: true,
    }
  },
  computed: {
    ...mapState({
      product: state => state.ui.product
    }),
    ...mapGetters({
      getYotpoReviews: 'yotpo/getProductReviews',
      getYotpoQuestions: 'yotpo/getProductQuestions',
    }),
    reviewsPrepared () {
      return this.yotpoReviews.reviews.slice(0, 6)
    },
    yotpoReviews () {
      return this.getYotpoReviews(this.product.productSku)
    },
    yotpoQuestions () {
      return this.getYotpoQuestions(this.product.productSku)
    },
    averageScore () {
      return this.yotpoReviews.bottomline.average_score
    },
    totalReviews () {
      return this.yotpoReviews.bottomline.total_review
    },
    totalQuestions () {
      return this.yotpoQuestions?.total_questions || 0
    },
  },
  mounted () {
    this.$nextTick(this.recalculate)
  },
  methods: {
    handleScroll () {
      this.recalculate()
    },
    recalculate () {
      if (!this.$refs.reviewsContainer) {
        setTimeout(this.recalculate, 100)
        return
      }

      const { scrollLeft, clientWidth, scrollWidth } = this.$refs.reviewsContainer
      this.isOnStart = scrollLeft === 0
      this.isOnEnd = Math.round(scrollLeft) + clientWidth >= scrollWidth
    },
    scrollRight () {
      if (this.isOnEnd) {
        return
      }

      const { scrollLeft, clientWidth, scrollWidth } = this.$refs.reviewsContainer
      this.performScroll(Math.min(scrollLeft + (clientWidth - 200), scrollWidth - clientWidth))
    },
    scrollLeft () {
      if (this.isOnStart) {
        return
      }

      const { scrollLeft, clientWidth } = this.$refs.reviewsContainer
      this.performScroll(Math.max(scrollLeft - (clientWidth - 200), 0))
    },
    performScroll (position) {
      this.$refs.reviewsContainer.scroll({
        left: position,
        behavior: 'smooth'
      })
    },
  }
}
